<template>
    <FormulateButton
        :title="context.label"
        :has-errors="this.context.attributes.hasErrors"
        :form-handler="this.context.attributes.formHandler"
    />
</template>

<script>
import FormulateButton from "../UI/FormulateButton";
export default {
    name: "SubmitButton",
    components: { FormulateButton },
    props: {
        context: {
            type: Object,
            required: true,
        },
    },
};
</script>
